import { useLayoutEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { links } from '@/utils/link'

type MeasureOneDataSourceConnectedEvent = CustomEvent<{
  data: {
    datasource_id: string
    datasource_name: string
  }
}>

interface MeasureOneWidgetProps {
  jobId: string
  config: string
  onTokenExpired: () => void
  addDataSource: (dataSourceId: string, dataSourceName: string) => void
}

export function MeasureOneWidget({
  config,
  jobId,
  onTokenExpired,
  addDataSource,
}: MeasureOneWidgetProps) {
  const m1WidgetRef = useRef<HTMLElement>(null)
  const navigate = useNavigate()

  useLayoutEffect(() => {
    const element = m1WidgetRef.current

    if (!element) {
      return
    }

    const onExit = () =>
      void navigate(links.jobDetails(jobId), { replace: true })

    const onDataSourceConnected = (event: Event) => {
      const { datasource_id: dataSourceId, datasource_name: dataSourceName } = (
        event as MeasureOneDataSourceConnectedEvent
      ).detail.data

      addDataSource(dataSourceId, dataSourceName)
    }

    element.addEventListener('exitRequested', onExit)
    element.addEventListener('tokenExpired', onTokenExpired)
    element.addEventListener('datasourceConnected', onDataSourceConnected)

    return () => {
      element.removeEventListener('exitRequested', onExit)
      element.removeEventListener('tokenExpired', onTokenExpired)
      element.removeEventListener('datasourceConnected', onDataSourceConnected)
    }
  }, [addDataSource, config, jobId, navigate, onTokenExpired])

  return <m1-link ref={m1WidgetRef} config={config} />
}
